import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { LogService } from '../services/log.service';
import { OrganizationService } from '../services/organization.service';
import { SessionService } from '../services/session.service';
import { RouterService } from '../services/router.service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  constructor(
    private session: SessionService,
    private router: RouterService,
    private log: LogService,
    private orgService: OrganizationService
  ) {}

  canActivate() {
    this.session.start();

    if (this.session.isAuthenticated()) {
      this.router.gotoHome();
      return false;
    }

    return true;
  }
}
